import React from 'react'
import Field from '../../common/Field'
import Validator from '../../common/Validator'
import Reflux from 'reflux'
import Store from '../../../store/store'
import moment from 'moment'
import 'moment/locale/hu'
import 'react-datepicker/dist/react-datepicker.css'
import i18 from '../../../i18'
import api from '../../../source/api'
import NotificationSystem from 'react-notification-system'
import DatePicker from 'react-date-picker';
import PATH from "../../../config/dev";


class Upload extends Reflux.Component {

    constructor(props) {
        super(props);
        this._notificationSystem = null;
        this.state = {
            userconfigs: props.userconfigs,
            company: props.company,
            companyName: props.company.name,
            processing: false,
            serverError: false,
            fields: {
                payment_method: {value: 'ALL', error: '', role: {required: true}},
                date_type: {value: 'issue', error: '', role: {required: true}},
                registration_number_transfer_huf: {value: '', error: '', role: {required: true}},
                registration_number_transfer_foreign: {value: '', error: '', role: {required: true}},
                registration_number_cash_huf: {value: '', error: '', role: {required: true}},
                registration_number_cash_foreign: {value: '', error: '', role: {required: true}},
                registration_number_card_huf: {value: '', error: '', role: {required: true}},
                registration_number_card_foreign: {value: '', error: '', role: {required: true}},
                registration_number_voucher_huf: {value: '', error: '', role: {required: true}},
                registration_number_voucher_foreign: {value: '', error: '', role: {required: true}},
                registration_number_other_huf: {value: '', error: '', role: {required: true}},
                registration_number_other_foreign: {value: '', error: '', role: {required: true}},
                export_date_type: {value: 'DELIVERY_DATE', error: '', role: {required: true}},
                job_number: {value: '', error: '', role: {required: false}},
            },
            company_id: props.location.match.params.id,
            start_date: new Date(),
            end_date: new Date(),
            date: {error: ''}
        };
        this.store = Store;
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
    };

    componentDidMount = () => {
        moment.locale('hu');
        this._notificationSystem = this.refs.notificationSystem;
        window.scrollTo(0, 0);
    };

    _addNotification = (msg, type, time = 30) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        });
    };

    handleStartDateChange = (date) => {
        this.setState({
            start_date: date
        });
    };

    handleEndDateChange = (date) => {
        this.setState({
            end_date: date
        });
    };

    static getDerivedStateFromProps (nextProps, prevState) {

        if (!nextProps.userconfigs) {
            return {
                userconfigs: nextProps.userconfigs,
                company: nextProps.company,
                companyName: nextProps.company.name,
            }
        }

        let fields = prevState.fields;

        fields.payment_method.value = nextProps.userconfigs.payment_method || 'ALL';
        fields.date_type.value = nextProps.userconfigs.date_type || 'issue';
        fields.registration_number_transfer_huf.value = nextProps.userconfigs.registration_number_transfer_huf;
        fields.registration_number_transfer_foreign.value = nextProps.userconfigs.registration_number_transfer_foreign;
        fields.registration_number_cash_huf.value = nextProps.userconfigs.registration_number_cash_huf;
        fields.registration_number_cash_foreign.value = nextProps.userconfigs.registration_number_cash_foreign;
        fields.registration_number_card_huf.value = nextProps.userconfigs.registration_number_card_huf;
        fields.registration_number_card_foreign.value = nextProps.userconfigs.registration_number_card_foreign;
        fields.registration_number_voucher_huf.value = nextProps.userconfigs.registration_number_voucher_huf;
        fields.registration_number_voucher_foreign.value = nextProps.userconfigs.registration_number_voucher_foreign;
        fields.registration_number_other_huf.value = nextProps.userconfigs.registration_number_other_huf;
        fields.registration_number_other_foreign.value = nextProps.userconfigs.registration_number_other_foreign;
        fields.export_date_type.value = nextProps.userconfigs.export_date_type || 'DELIVERY_DATE';
        fields.job_number.value = nextProps.userconfigs.job_number;

        if (nextProps.company) {
            return {
                userconfigs: nextProps.userconfigs,
                company: nextProps.company,
                companyName: nextProps.company.name,
                fields: fields,
                start_date: nextProps.userconfigs.start_date ? new Date(nextProps.userconfigs.start_date) : new Date(),
                end_date: nextProps.userconfigs.end_date ? new Date(nextProps.userconfigs.end_date) : new Date(),
            }
        }

        return {
            userconfigs: nextProps.userconfigs,
            fields: fields,
            start_date: nextProps.userconfigs.start_date ? new Date(nextProps.userconfigs.start_date) : new Date(),
            end_date: nextProps.userconfigs.end_date ? new Date(nextProps.userconfigs.end_date) : new Date(),
        }
    };

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value;
        fields[name].error = error;
        this.setState({fields: fields});
    };

    buildSubmitForm = () => {
        let form = new FormData();
        form.append('payment_method', this.state.fields.payment_method.value);
        form.append('date_type', this.state.fields.date_type.value);
        form.append('start_date', moment(this.state.start_date).format('YYYY-MM-DD'));
        form.append('end_date', moment(this.state.end_date).format('YYYY-MM-DD'));
        form.append('registration_number_transfer_huf', this.state.fields.registration_number_transfer_huf.value);
        form.append('registration_number_transfer_foreign', this.state.fields.registration_number_transfer_foreign.value);
        form.append('registration_number_cash_huf', this.state.fields.registration_number_cash_huf.value);
        form.append('registration_number_cash_foreign', this.state.fields.registration_number_cash_foreign.value);
        form.append('registration_number_card_huf', this.state.fields.registration_number_card_huf.value);
        form.append('registration_number_card_foreign', this.state.fields.registration_number_card_foreign.value);
        form.append('registration_number_voucher_huf', this.state.fields.registration_number_voucher_huf.value);
        form.append('registration_number_voucher_foreign', this.state.fields.registration_number_voucher_foreign.value);
        form.append('registration_number_other_huf', this.state.fields.registration_number_other_huf.value);
        form.append('registration_number_other_foreign', this.state.fields.registration_number_other_foreign.value);
        form.append('export_date_type', this.state.fields.export_date_type.value);
        form.append('job_number', this.state.fields.job_number.value);
        return form;
    };

    export = () => {
        document.body.classList.toggle('loading-body', true);
        this.setState({processing: true});

        let form = new FormData();
        form.append('payment_method', this.state.fields.payment_method.value);
        form.append('date_type', this.state.fields.date_type.value);
        form.append('start_date', moment(this.state.start_date).format('YYYY-MM-DD'));
        form.append('end_date', moment(this.state.end_date).format('YYYY-MM-DD'));


        api.post({url: 'supplier/export/generate?company_id=' + this.state.company.id, data: form}, true).then((response) => {
            document.body.classList.remove('loading-body');

            window.open(
                PATH.ENDPOINT_BASE_URL + 'supplier/export/download'
                + '?auth_token=' + api.getToken()
                + '&company_id=' + this.state.company.id
                + '&name=' + response.data.url
            );

        }).catch((err) => {
            console.log(err);
            document.body.classList.remove('loading-body');
            this.setState({processing: false});
            this._addNotification(err.response.data.error.message, 'error');
        });
    }

    nextStep = () => {
        let self = this;
        document.body.classList.toggle('loading-body', true);
        this.setState({processing: true});

        let validator = Validator.validate(this.state.fields);
        if (validator.error) {
            document.body.classList.remove('loading-body')
            this.setState({
                processing: false,
                fields: validator.fields,
                error: validator.error
            });
            return;
        }

        if (this.state.error || this.state.date.error) {
            document.body.classList.remove('loading-body');
            this.setState({processing: false});
            return;
        }

        var form = this.buildSubmitForm();
        api.post({url: 'supplier/steps/upload?company_id=' + this.state.company.id, data: form}, true).then((response) => {
            document.body.classList.remove('loading-body');
            let invoices = response.data.invoices;
            self.props.updateInvoices(invoices, self.props.supplierRules);

            this.props.setData({
                processing: false,
                invoices: invoices,
                currentStep: 2,
            });
        }).catch((err) => {
            console.log(err);
            document.body.classList.remove('loading-body');
            this.setState({processing: false});
            this._addNotification(err.response.data.error.message, 'error');
        });
    };

    onChangeSelect = (event) => {
        let fields = this.state.fields;
        fields[event.target.name].value = event.target.value;
        this.setState({fields: fields})
    }

    render() {
        return (
            <div className='col-md-10 offset-md-1'>
                <div className='row'>
                    <div className='col-3'>
                        <select value={this.state.fields.payment_method.value}
                                name='payment_method'
                                onChange={(event) => this.onChangeSelect(event)}
                                className='minimal-100  form-control'>
                            <option value='ALL'>Minden fizetési mód</option>
                            <option value='TRANSFER'>Utalás</option>
                            <option value='CASH'>Készpénz</option>
                            <option value='CARD'>Kártya</option>
                            <option value='VOUCHER'>Utalvány</option>
                            <option value='OTHER'>Egyéb</option>
                        </select>
                    </div>
                    <div className='col-3'>
                        <select value={this.state.fields.date_type.value}
                                name='date_type'
                                onChange={(event) => this.onChangeSelect(event)}
                                className='minimal-100  form-control'>
                            <option value='issue'>Kiállítás alapján</option>
                            <option value='delivery'>Teljesítés alapján</option>
                        </select>
                    </div>
                    <div className='col-3'>
                        <DatePicker
                            className="date-picker"
                            required={true}
                            locale="hu-HU"
                            onChange={this.handleStartDateChange}
                            value={this.state.start_date}
                        />
                    </div>
                    <div className='col-3'>
                        <DatePicker
                            className="date-picker"
                            locale="hu-HU"
                            onChange={this.handleEndDateChange}
                            value={this.state.end_date}
                        />
                    </div>
                </div>

                {this.state.date.error
                    ? <p className='help-block help-block-error'>
                        <span className='error'><i className='fa fa-warning'/> {this.state.date.error}</span>
                    </p>
                    : null
                }
                <table className='table table-striped  table-aibook-bordered'>
                    <thead>
                    <tr>
                        <th style={{width: '50%'}}>Fizetés típusa</th>
                        <th style={{width: '25%'}}>Forintos</th>
                        <th style={{width: '25%'}}>Devizás</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>KÉSZPÉNZES SZÁMLÁK RÖGZÍTÉSE</td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_cash_huf'
                                name='registration_number_cash_huf'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_cash_foreign'
                                name='registration_number_cash_foreign'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>ÁTUTALÁSOS SZÁMLÁK RÖGZÍTÉSE</td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_transfer_huf'
                                name='registration_number_transfer_huf'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_transfer_foreign'
                                name='registration_number_transfer_foreign'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>BANKKÁRTYÁS SZÁMLÁK RÖGZÍTÉSE</td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_card_huf'
                                name='registration_number_card_huf'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_card_foreign'
                                name='registration_number_card_foreign'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>UTALVÁNYOS SZÁMLÁK RÖGZÍTÉSE</td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_voucher_huf'
                                name='registration_number_voucher_huf'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_voucher_foreign'
                                name='registration_number_voucher_foreign'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>EGYÉB SZÁMLÁK RÖGZÍTÉSE</td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_other_huf'
                                name='registration_number_other_huf'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                        <td className='text-center'>
                            <Field
                                type='text'
                                id='registration_number_other_foreign'
                                name='registration_number_other_foreign'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Exportban szereplő dátum érték</td>
                        <td colSpan='2' className='text-center'>
                            <select value={this.state.fields.export_date_type.value}
                                    name='export_date_type'
                                    onChange={(event) => this.onChangeSelect(event)}
                                    className='minimal-100  form-control'>
                                <option value='DELIVERY_DATE'>Teljesítés dátuma</option>
                                <option value='ISSUE_DATE'>Kelte dátuma</option>
                            </select>
                        </td>
                    </tr>
                    {this.state.company && this.state.company.accountant_program_id === 3
                        ? <tr>
                            <td>Munkaszám</td>
                            <td colSpan="2" className="text-right">
                                <Field
                                    type='text'
                                    id='job_number'
                                    name='job_number'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </td>
                        </tr>
                        : null
                    }
                    </tbody>
                </table>
                <div className='row'>
                    <div className='col-12'>
                        <div className='next-step-btn-container'>
                            <a onClick={() => this.export()} className='next-step mr-2'>Számlák excel exportálása</a>
                            <a onClick={() => this.nextStep()} className='next-step'>{i18.BUTTONS._goToAccountAssignment}</a>
                        </div>
                    </div>
                </div>
                <NotificationSystem ref='notificationSystem'/>
            </div>
        )
    }
}

export default Upload


// WEBPACK FOOTER //
// ./src/components/supplier/steps/upload.js